
import { styled } from '@core-ui/react-stitch';

const DrawerContent = styled.div(() => ({
  textAlign: 'left',
  height: '100%',
  flexDirection: 'column',
  justifyContent: 'space-between',
  display: 'flex',
  boxSizing: 'border-box',
}));

export default DrawerContent;
